module.exports = __webpack_public_path__ + "static/media/icon_207.8497a212.svg";